const getTotalPrice = (visitors, visitorsFees, theatres, theatresFees, extra_price) => {
    let totalTotal = 0;

    [visitors, visitorsFees, theatres, theatresFees].forEach(priceItems => {
        if(priceItems)  {
            totalTotal += priceItems.totalPrice
        }
    })

    totalTotal += extra_price

    return totalTotal
}

export default getTotalPrice